import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";

interface PageTransitionProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Wraps page content to provide a fade+slide-up animation on route changes.
 * Uses CSS-only transitions — no external dependencies.
 */
export function PageTransition({
  children,
  className = "",
}: PageTransitionProps) {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(true);
  const prevPathRef = useRef(location.pathname);

  useEffect(() => {
    if (prevPathRef.current !== location.pathname) {
      // Briefly hide to trigger re-animation
      setIsVisible(false);
      const timer = requestAnimationFrame(() => {
        setIsVisible(true);
      });
      prevPathRef.current = location.pathname;
      return () => cancelAnimationFrame(timer);
    }
  }, [location.pathname]);

  return (
    <div
      key={location.pathname}
      className={`${className} ${isVisible ? "animate-page-enter" : "opacity-0"}`}
    >
      {children}
    </div>
  );
}
